import React, {FC, useCallback} from 'react';
import { IconButton } from '@material-ui/core';
import { Add, Remove } from '@material-ui/icons';
import styles from '../Button.module.scss';

interface ButtonNumberProps {
    value: number;
    min?: number;
    max?: number;
    onChange: (newValue: number) => void;
    className?: string;
    disabled?: boolean;
}

export const ButtonNumber: FC<ButtonNumberProps> = ({value = 0, min = 0, max = Infinity, onChange, className = '', disabled = false}) => {
    const isMinValue = value <= min;
    const isMaxValue = value >= max;

    const handleDecrement = useCallback(() => {
        if (!isMinValue) {
            onChange(value - 1);
        }
    }, [value, onChange, isMinValue]);

    const handleIncrement = useCallback(() => {
        if (!isMaxValue) {
            onChange(value + 1);
        }
    }, [value, onChange, isMaxValue]);

    return (
        <div className={`${styles.container} ${className}`}>
            <IconButton
                size="small"
                onClick={handleDecrement}
                disabled={isMinValue || disabled}
                className={`${styles.button}`}
            >
                <Remove fontSize="small" />
            </IconButton>
            <div className={styles.valueContainer}>
                <span className={styles.value}>{value}</span>
            </div>
            <IconButton
                size="small"
                onClick={handleIncrement}
                disabled={isMaxValue || disabled}
                className={`${styles.button}`}
            >
                <Add fontSize="small" />
            </IconButton>
        </div>
    );
};